<fs-menu-simple
        [itemsList]='this.getLanguages()'
        [selectedItem]='selectedMenuLanguage'
        [leadingIcon]="'./libs/shared-ui/assets/icons/globe.svg'"
        (onSelect)="languageMenuPress($event)">
</fs-menu-simple>